<!-- Footer: tabs Debate / Notas con nuevo diseño. Lógica original intacta (changeState / linkState / previewMode). -->
<div id="footer" class="slide rounded-x-2xl ">
    <div [ngClass]="{ 'disabled': previewMode }">
        <div class="mx-1 border border-[#E8EAEF] rounded-2xl overflow-hidden">

            <!-- Tabs: usa changeState('discussion'|'notes') y resalta el activo según linkState.
                 Con debate habilitado se muestran 2 pestañas (grid-cols-2); si solo existe Notas,
                 ocupa todo el ancho (grid-cols-1) para verse como una única card. -->
            <div class="grid border-b border-[#E8EAEF]"
                [ngClass]="course?.discussionEnabled ? 'grid-cols-2' : 'grid-cols-1'">
                <ng-container *ngIf="course?.discussionEnabled">
                    <button
                        (click)="changeState('discussion')"
                        class="flex items-center justify-center gap-2 py-3.5 text-sm font-semibold border-b-2 transition-colors"
                        [style.border-color]="linkState === 'discussion' ? 'var(--primary-color)' : 'transparent'"
                        [style.border-bottom]="linkState === 'discussion' ? '1.8px solid var(--primary-color)' : null"
                        [style.color]="linkState === 'discussion' ? 'var(--primary-color)' : '#5F6877'"
                    >
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                            <path d="M7.9 20A9 9 0 1 0 4 16.1L2 22Z"></path>
                        </svg>
                        {{ 'player.footer.tab-discussion' | translate }}
                    </button>
                </ng-container>

                <button
                    (click)="changeState('notes')"
                    class="flex items-center justify-center gap-2 py-3.5 text-sm font-semibold border-b-2 transition-colors hover:text-[#22304C]"
                    [style.border-color]="linkState === 'notes' ? 'var(--secondary-color)' : 'transparent'"
                    [style.border-bottom]="linkState === 'notes' ? '1px solid var(--secondary-color)' : null"
                    [style.color]="linkState === 'notes' ? 'var(--secondary-color)' : '#5F6877'"
                >
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
                        <path d="M16 3H5a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V8Z"></path>
                        <path d="M15 3v4a2 2 0 0 0 2 2h4"></path>
                    </svg>
                    {{ 'player.footer.tab-notes' | translate }}
                </button>
            </div>

            <!-- Contenido de cada tab; se mantienen los componentes existentes msc-note / app-timeline -->
            <div class="div-debate p-4">
                <div *ngIf="linkState === 'notes'">
                    <msc-note></msc-note>
                </div>

                <div *ngIf="linkState === 'discussion'">
                    <app-timeline [context]="context" [contextId]="contextId"></app-timeline>
                </div>
            </div>
        </div>
    </div>
    <div class="footer__overlay" *ngIf="previewMode">
        {{ 'player.discussion-note-disabled' | translate }}
    </div>
</div>
